import type { StatusOption } from "../api";

/** Картинка варианта состояния устройства */
export function getStatusOptionImageUrl(option: StatusOption): string {
    return `${import.meta.env.VITE_IT4_HOST_PREVIEW}/attach/get2/${option.imgCid}`;
}
